
import { useState } from "react";
import a1 from "../imgs/logo.jpg"
import { useNavigate } from "react-router-dom";

const NavBar = () => {
    const nav = useNavigate('');
    const [keysrch , setsrch] = useState('');
    return (
        <>
            <nav class="navbar navbar-expand-lg " layout="responsive">
                <div class="container-fluid">
                    <a class="navbar-brand" href="#"> <div className="log">
                        <img src={a1} width={400} />
                    </div> </a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                        <div class="navbar-nav">
                             <form className="">
                                <div class="input-group" id="inp">
                                    <input type="text" onChange={(e)=>setsrch(e.target.value)} class="form-control" placeholder="Search Product" />
                                    <span onClick={()=>nav(`/search?search=${keysrch}`)} class="input-group-text" id="basic-addon1"> <i class="fa-solid fa-magnifying-glass"> </i> </span>
                                </div>
                            </form>
                               <div className="un nav-item">
                                <i class="fa-solid fa-user" onClick={()=>nav('/profile')} title="profile"></i>
                                <i class="fa-solid fa-cart-shopping" onClick={()=>nav('/cart')} title="cart"></i>
                                <i class="fa-solid fa-cart-shopping" onClick={()=>nav('/order')} title="orders"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

                
            <div className="rtk mt-3">
                <div onClick={()=>nav('/')}> Home </div>
                <div onClick={()=>nav('/shop')}> Shop </div>
                <div> About </div>
                <div onClick={()=>nav('/login')}> Login </div>
            </div>

        </>
    )
}

export default NavBar;